import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TablePagination,
  TableSortLabel,
  Paper,
} from "@mui/material";
import TableContainer from "@mui/material/TableContainer";

export default function useTableFijo3(
  records,
  headCells,
  filterFn,
  heightTabla,
) {
  //const pages = [5, 10, 25, records.length]
  const pages = [5, 10, 25, 50];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[page]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();

  const TblContainer3 = (props) => (
    <div
      className="table-sm border-table p-0 fixed rounded"
      style={props.container}
    >
      <table className="table table-striped table-hover table-sm">
        {props.children}
      </table>
    </div>
  );

  const TblHead3 = (props) => {
    const handleSortRequest = (cellId) => {
      const isAsc = orderBy === cellId && order === "asc";
      setOrder(isAsc ? "desc" : "asc");
      setOrderBy(cellId);
    };

    return (
      <TableHead>
        <tr>
          {headCells.map((headCell) => (
            <td
              className="letra-tabla-th"
              key={headCell.id}
              style={{
                color: headCell.color,
                backgroundColor: headCell.backgroundColor,
                fontSize: "10px",
                textAlign: headCell.textAlign,
                textTransform: 'uppercase',
                fontWeight: "bold" /*, minWidth:headCell.width*/,
              }}
              width={headCell.width}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              {headCell.label}
              {/*                             {headCell.disableSorting ? headCell.label :
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                 onClick={() => { handleSortRequest(headCell.id) }} >
                                {headCell.label}
                            </TableSortLabel>
                        } */}
            </td>
          ))}
        </tr>
      </TableHead>
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination3 = () => (
    <TablePagination
      component="div"
      page={page}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      labelRowsPerPage="Filas por Paginas"
      count={records.length}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
    />
  );

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => descendingComparator(a, b, orderBy)
      : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  const recordsAfterPagingAndSorting3 = () => {
    return stableSort(
      filterFn.fn(records),
      getComparator(order, orderBy),
    ).slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  };

  return {
    TblContainer3,
    TblHead3,
    TblPagination3,
    recordsAfterPagingAndSorting3,
  };
}
